import { ISchool } from '../../../interfaces/school.interface'
import HorizontalScrollWrapperComponent from '../../Scroll/HorizontalScrollWrapperComponent'
import * as React from 'react'
import Link from 'next/link'
import {
  Button,
  Card,
  CardActions,
  CardContent,
  Divider,
  Typography,
} from '@mui/material'
import CourseCardPriceComponent from '../../SchoolHomepage/DefaultHomepage/CourseCardPriceComponent'
import Image from 'next/image'
import { getNextCardImageSrc } from '@/components/ExtraStyleLogic/cardImages'

export default function CourseDetailsOtherCoursesComponent(props: {
  schoolDetailsFromCourse: ISchool
  currentCourseId?: string
}) {
  const [courseList] = React.useState(generateCourseList())
  const [backgroundImage, setBackgroundImage] = React.useState<string>('')

  React.useEffect(() => {
    setBackgroundImage(getNextCardImageSrc())
  }, [])

  function generateCourseList() {
    return props.schoolDetailsFromCourse?.course_summary?.filter(
      c => c._id !== props.currentCourseId,
    )
  }

  if (courseList?.length === 0) {
    return <div />
  }

  return (
    <div
      style={{
        padding: '60px 0px 100px 0px',
        maxWidth: '1300px',
        margin: 'auto',
      }}
    >
      <div style={{ padding: '10px' }}>
        <Typography style={{ color: '#fff' }} variant={'h5'}>
          <b> Related Courses</b>
        </Typography>
      </div>
      <HorizontalScrollWrapperComponent buttonStyle={{ color: 'inherit' }}>
        <div
          style={{
            display: 'flex',
            width: '100%',
          }}
        >
          {courseList?.map(c => {
            return (
              <React.Fragment key={c._id}>
                <Card
                  variant="outlined"
                  key={c._id}
                  style={{
                    width: '100%',
                    margin: '10px',
                    maxWidth: '300px',
                    minWidth: '300px',
                    // backgroundColor: "#212330",
                    // backgroundColor: '#25282b',
                    // color: '#fafafa',
                  }}
                >
                  <div
                    style={{
                      position: 'relative',
                    }}
                  >
                    {c.background_image ? (
                      <Image
                        style={{ objectFit: 'cover' }}
                        objectFit={'cover'}
                        src={c.background_image}
                        height={'150'}
                        width={'300'}
                        unoptimized={true} // to reduce load on server for now
                        alt="background image"
                      />
                    ) : (
                      <Image
                        style={{ objectFit: 'cover' }}
                        objectFit={'cover'}
                        src={backgroundImage || '/static/img/placeholder.svg'}
                        height={'150'}
                        width={'300'}
                        unoptimized={true} // to reduce load on server for now
                        alt="background image"
                      />
                    )}
                  </div>
                  <CardContent
                    component="div"
                    style={{ height: '100px', overflow: 'hidden' }}
                  >
                    <Typography
                      style={{
                        fontSize: '1.2rem',
                      }}
                      variant="h6"
                    >
                      {c.name}
                    </Typography>

                    <Typography
                      variant="body2"
                      style={{
                        // whiteSpace: "nowrap",
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        height: '40px',
                      }}
                    >
                      {c.short_description}
                    </Typography>
                  </CardContent>
                  <Divider />
                  <CardActions
                    style={{
                      display: 'flex',
                      padding: '16px',
                    }}
                  >
                    <>
                      {!c.isComingSoon && (
                        <Link href={`/course-details/${c?.slug || c?._id}`}>
                          <Button
                            variant={'contained'}
                            color={'primary'}
                            disableElevation={true}
                            size={'small'}
                            style={{ borderRadius: '10px' }}
                          >
                            {'Open course'}
                          </Button>
                        </Link>
                      )}
                      {c.isComingSoon && (
                        <Typography variant={'body2'} color={'primary'}>
                          <i>Coming soon</i>
                        </Typography>
                      )}
                      <span style={{ display: 'flex', flexGrow: 1 }} />
                      <CourseCardPriceComponent
                        school={props.schoolDetailsFromCourse}
                        course={c as any}
                      />
                    </>
                  </CardActions>
                </Card>
              </React.Fragment>
            )
          })}
        </div>
      </HorizontalScrollWrapperComponent>
    </div>
  )
}
